const availableMessageTypes = [
  {
    label: 'WhatsApp',
    code: 'whatsapp'
  },
  {
    label: 'Email',
    code: 'email'
  },

]

export default availableMessageTypes
